/**
 * @author：
 * @update：
 * @description：
 **/
import {fileUp,fileEcho,goodsClassList,receptionClassList,floorStyle,goodeReviewedList2,addReceptionClassList,searchReceptionClassList,editReceptionClassList} from "../../api/url";
import CusPagination from '@/components/cusPagination.vue';
var listData;
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            classId:'',//详情id
            fileUp:fileUp,
            fileEcho:fileEcho,
            token:{'Authorization':'Bearer '+ sessionStorage.getItem('token')},
            className:'',//分类名称
            parentClass:[],//关联后台分类
            parentClassValue:'',//关联后台分类选择的值
            classification:[],//关联后台分类
            classificationValue:'',//关联后台分类选择的值
            classificationChildren:false,//关联后台分类编辑时是否有子集
            classImg:'',//分类图标
            loading:false,
            method:'CUSTOMIZE',//配置方式
            bannerData:[],//banner
            floorData:[],//楼层数据
            linkUrl:'',//跳转链接
            wrapEnabled:true,//整体启禁用

            /*新增/编辑banner*/
            bannerIsEdit:false,//是否是编辑
            bannerIsEditIndex:'',//编辑第几个
            bannerVisible:false,//banner弹窗
            bannerImg:'',//新增banner
            bannerLinkUrl:'',//新增banner跳转链接

            /*新增/编辑层*/
            floorVisible:false,//楼层弹窗
            floorIsEdit:false,//是否是编辑
            floorIsEditIndex:'',//编辑第几个
            floorName:'',//楼层名称
            floorExplain:'',//楼层简介
            relation:false,//是否关联
            categoryId:['0'],
            options: [],
            floorList:[],//楼层样式展示
            floorSelect:'',//楼层样式选择
            floorStyleTextIndex:0,//提示内容
            floorStyleId:'',//楼层样式选择的id
            floorStyleText:[
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：拥有小分类，需要1-6个分类标题；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，每个分类下大于等于6个商品，前6个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：左右翻页、划过图片变彩色；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，需添加商品个数为4的整数倍，其中每4个为一组，可左右翻页显示，没有查看更多操作</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：交错显示；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数为6，没有查看更多</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：白底双排商品，商品有框显示；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数大于等于10个，前10个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：蓝色渐变底色双排商品，有查看更多；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数大于等于10个，前10个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：蓝色渐变底色单排商品，大商品图布局，有查看更多</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数大于等于4个，前4个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;"></p><p style="color: #636F98;font-size: 12px;text-indent: 85px"></p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：白底双排商品，划过商品可收藏，商品无边框，商品有星级推荐，有查看更多 </p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数大于等于10个，前10个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：拥有小分类，需要1-6个分类标题；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，每个分类下大于等于6个商品，前6个商品可显示在楼层中，其他商品点击查看详更多均可看到</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：左右翻页、划过图片变彩色；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，需添加商品个数为4的整数倍，其中每4个为一组，可左右翻页显示，没有查看更多操作</p>'},
                {text:'<p style="color: #636F98;font-size: 12px;">楼层样式提示：1，该楼层特色：交错显示；</p><p style="color: #636F98;font-size: 12px;text-indent: 85px">2，商品个数为6，没有查看更多</p>'},
             ],//楼层样式文字说明
            floorClassData:[],//分类楼层列表
            floorClassDataAnother:[],//除floor1对应的分类数据
            enableVal:true,//启禁用

            //分类弹窗
            classVisible:false,
            classIsEdit:false,//是否是编辑
            classEditIndex:'',//编辑第几个
            classTitle:'',//分类标题
            floorClassData2:[],//分类楼层数据

            //定价属性分组
            priceGrouping:false,//商品属性分组弹窗
            priceGroupingSearchName:'',//搜索的属性名称
            priceGroupingSearchList:[],//搜索数据
            priceGroupingSearchActiveList:[],//选择的数据
            priceGroupingGroupingPage:1,//搜索数据分页
            priceGroupingGroupingSize:5,//搜索数据个数
            priceGroupingGroupingCount:0,//搜索数据总数

            radioDisable:false,
            //关联分类初始化状态
            relationType:false,//true 第一次初始化 false 非初始化
            isConfirm:true,//是否显示确认
        };
    },
    // 自定义方法
    methods: {
        //url验证
        urlInspect(value){
            if(value!=""){
                let reg=/(http|https):\/\/([\w.]+\/?)\S*/;
                if(!reg.test(value)){
                    this.$message({
                        showClose:true,
                        message:"您输入的网址不正确,必须以http,https开头,且需符合URL规范",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }else{
                    return true
                }
            }
        },
        //获取必要数据
        classificationList(){
            //前台分类
            this.$ajax.get(receptionClassList).then(res=>{
                console.log(res);
                let optionsArr = [{name:'全部',id:'0'}];
                for(let i = 0; i < res.data.length; i++){
                    let obj = {};
                    obj.name = res.data[i].name;
                    obj.id = res.data[i].id;
                    obj.children = res.data[i].children;
                    obj.leaf = res.data[i].leaf;
                    optionsArr.push(obj)
                }
                this.options = this.getTreeData(optionsArr);
                let arr = [];
                for(let i = 0; i < res.data.length; i++){
                    let obj = {};
                    obj.value =  res.data[i].id;
                    obj.label = res.data[i].name;
                    if(res.data[i].children!=undefined&&res.data[i].children.length!=0){
                        let arr2 = [];
                        for(let j = 0; j < res.data[i].children.length; j++){
                            let obj2 = {};
                            obj2.value = res.data[i].children[j].id;
                            obj2.label = res.data[i].children[j].name;
                            arr2.push(obj2)
                        }
                        obj.children = arr2;
                    }
                    arr.push(obj)
                }
                this.parentClass = arr;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
            //后台分类
            this.$ajax.get(goodsClassList).then(res=>{
                console.log(res);
                let arr = [];
                for(let i = 0; i < res.data.length; i++){
                    let obj = {};
                    obj.value =  res.data[i].id;
                    obj.label = res.data[i].name;
                    if(res.data[i].children!=undefined&&res.data[i].children.length!=0){
                        let arr2 = [];
                        for(let j = 0; j < res.data[i].children.length; j++){
                            let obj2 = {};
                            obj2.value = res.data[i].children[j].id;
                            obj2.label = res.data[i].children[j].name;
                            if(res.data[i].children[j].children!=undefined&&res.data[i].children[j].children.length!=0){
                                let arr3 = [];
                                for(let k = 0; k < res.data[i].children[j].children.length; k++) {
                                    let obj3 = {};
                                    obj3.value = res.data[i].children[j].children[k].id;
                                    obj3.label = res.data[i].children[j].children[k].name;
                                    arr3.push(obj3)
                                }
                                obj2.children = arr3;
                            }
                            arr2.push(obj2)
                        }
                        obj.children = arr2;
                    }
                    arr.push(obj)
                }
                this.classification = arr;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //递归遍历设置children
        getTreeData(data){
            // 循环遍历json数据
            for(let i=0;i<data.length;i++){
                if(data[i].children==undefined||data[i].children.length==0){
                    // children若为空数组，则将children设为undefined
                    data[i].children=undefined;
                }else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].children);
                }
            }
            return data;
        },
        //上传图片回调
        onBeforeUpload(file){
            if (file.type!== 'image/jpeg'&&file.type!== 'image/jpg'&&file.type!== 'image/png'&&file.type!== 'image/webp') {
                this.$message({
                    showClose:true,
                    message:"请上传正确的图片格式!",
                    type:"error",
                    center:true,
                    duration:3000
                })
                setTimeout(function(){
                    this.loading = false;
                }.bind(this),500)
                return false
            }
        },
        upLoad(res, file) {
            console.log(file);
            let data = res;
            data.type = res.ext;
            data.id = null;
            // data.filename = res.originName;
            this.classImg=data;
            let that = this;
            setTimeout(function(){
                that.loading = false
            },300)
        },
        bannerUpLoad(res, file) {
            console.log(file);
            let data = res;
            data.type = res.ext;
            data.id = null;
            data.isNewFile = true;
            // data.filename = res.originName;
            this.bannerImg=data;
            let that = this;
            setTimeout(function(){
                that.loading = false
            },300)
        },
        changeFun(){
            this.loading = true
        },
        errorFun(){
            this.loading = false
        },
        //分类图删除
        delImg(){
            this.classImg= '';
        },
        //上移
        upItem(index,data) {
            if(index==0){
                return false
            }
            const upDate = data[index - 1];
            data.splice(index - 1, 1);
            data.splice(index, 0, upDate);

        },
        //下移
        downItem(index,data) {
            if(index == data.length-1){
                return false
            }
            const downDate = data[index + 1];
            data.splice(index + 1, 1);
            data.splice(index, 0, downDate);
        },
        //删除弹窗
        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },

        /*banner弹窗*/
        //banner删除
        delBanner(index){
            this.bannerData.splice(index, 1);
        },
        //banner编辑
        editBanner(index){
            let data = this.bannerData[index];
            this.bannerImg=data.bannerImg;
            this.bannerLinkUrl=data.bannerLinkUrl;
            this.bannerIsEdit = true;
            this.bannerIsEditIndex = index;
            this.bannerVisible=true;
        },
        //打开Banner弹窗并重置内容
        openBannerWrap(){
            this.bannerImg='';
            this.bannerLinkUrl='';
            this.bannerIsEdit = false;
            this.bannerIsEditIndex = '';
            this.bannerVisible = true;
        },
        //Banner弹窗提交内容
        bannerWrapBtn(){
            let bol = this.urlInspect(this.bannerLinkUrl);
            if(bol==false){
                return false
            }
            if(this.bannerIsEdit){
                let data = this.bannerData;
                if(this.bannerImg.isNewFile == true){
                    delete data[this.bannerIsEditIndex].mediaItemsId;
                }
                data[this.bannerIsEditIndex].bannerImg = this.bannerImg;
                data[this.bannerIsEditIndex].bannerLinkUrl=this.bannerLinkUrl;
                this.bannerData = [...data];
            }else{
                let arr = [{bannerImg:this.bannerImg,bannerLinkUrl:this.bannerLinkUrl}];
                this.bannerData = [...this.bannerData,...arr]
            }
            this.bannerVisible = false;
        },
        //删除图片
        bannerDelImg(){
            this.bannerImg= '';
        },

        /*新建编辑楼层*/
        //打开楼层重置数据
        openFloorWrap(bol,index){
            this.$ajax.get(floorStyle).then(res=>{
                console.log(res);
                let data = res.data.rows;
                if(bol){
                    listData = this.floorData[index];
                    for(let i = 0; i < data.length; i++){
                        if(listData.floorId==data[i].id){
                            this.floorStyleTextIndex= Number(data[i].style.split('floor')[1]-1);
                            this.floorStyleId = data[i].id;
                            this.floorSelect = data[i].style;
                            data[i].selectActive = true
                        }else{
                            data[i].selectActive = false
                        }
                    }
                    this.floorList = data;
                    this.floorName=listData.name;//楼层名称
                    this.floorExplain=listData.explain;//楼层简介
                    this.relation = listData.relation;
                    if(this.relation){
                        this.categoryId=listData.categoryId;
                    }
                    this.floorIsEdit=true;//是否是编辑
                    this.enableVal = listData.enabled;
                    this.floorIsEditIndex=index;//编辑第几个
                    if(listData.style=='floor1'){
                        this.floorClassData = [...listData.data];
                    }else{
                        this.floorClassDataAnother = [...listData.data];
                    }
                    this.floorVisible = true;
                }else{
                    for(let i = 0; i < data.length; i++){
                        if(i==0){
                            this.floorStyleTextIndex= Number(data[0].style.split('floor')[1]-1);
                            this.floorStyleId = data[0].id;
                            this.floorSelect = data[0].style;
                            data[0].selectActive = true
                        }else{
                            data[i].selectActive = false
                        }
                    }
                    this.floorList = data;
                    this.floorName='';//楼层名称
                    this.floorExplain='';//楼层简介
                    this.relation=false;//是否关联
                    this.categoryId=['0'];
                    this.floorIsEdit=false;//是否是编辑
                    this.enableVal = true;
                    this.floorIsEditIndex='';//编辑第几个
                    this.floorClassData = [];//分类楼层列表
                    this.floorClassDataAnother = [];//除floor1外所有楼层
                    this.floorVisible = true;
                }

            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //选择的楼层样式
        floorChange(index){
            let data = this.floorList;
            this.floorStyleTextIndex= Number(data[index].style.split('floor')[1]-1);
            this.floorStyleId = data[index].id;
            this.floorSelect = data[index].style;
            this.floorClassData = [];//floor1对应的分类数据清空
            this.floorClassDataAnother = [];//除floor1对应的分类数据清空
            for(let i = 0; i < data.length; i++){
                if(i==index){
                    data[i].selectActive = true;
                }else{
                    data[i].selectActive = false;
                }
            };
        },
        //分类楼层编辑
        editFloorClassData(index){
            let data = this.floorClassData[index];
            this.classTitle=data.name;//分类名称
            this.floorClassData2=[...data.data];//分类商品列表
            this.classIsEdit=true;//是否是编辑
            this.classEditIndex=index;//编辑第几个
            // this.categoryId=this.floorData[index].categoryId;
            this.classVisible=true;
        },
        //分类楼层删除
        delFloorClassData(index){
            this.floorClassData.splice(index, 1);
        },
        //添加编辑楼层删除列表
        delFloorClassDataAnother(index){
            this.floorClassDataAnother.splice(index, 1);
        },
        //楼层提交
        floorWrapBtn(){
            if(this.floorName==''){
                this.$message({
                    showClose:true,
                    message:"请输入楼层名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.floorExplain==''){
                this.$message({
                    showClose:true,
                    message:"请输入楼层简介",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.floorSelect=='floor1'){
                let arr = [...this.floorData];
                let obj = {floorId:this.floorStyleId,style:this.floorSelect,name:this.floorName,enabled:this.enableVal,explain:this.floorExplain,data:[...this.floorClassData],relation:this.relation};
                if(this.relation){
                    obj.categoryId=this.categoryId
                }
                let num = 0;
                for(let i = 0; i < obj.data.length; i++){
                    num += obj.data[i].data.length
                }
                obj.goodsNumber = num;
                if(this.floorIsEdit){
                    if(this.classId!='') {
                        obj.id = this.floorData[this.floorIsEditIndex].id||'';
                        obj.rowId = this.floorData[this.floorIsEditIndex].rowId||'';
                    }
                    arr[this.floorIsEditIndex] = obj;
                    this.floorData = arr
                }else{
                    arr.push(obj);
                    this.floorData = arr;
                }
            }else{
                let num = this.floorClassDataAnother.length;
                if(num==0){
                    this.$message({
                        showClose:true,
                        message:"请添加商品",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }else{
                    if(this.floorStyleTextIndex=='1'){
                        if(num<4){
                            this.$message({
                                showClose:true,
                                message:"该楼层至少添加4件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }else{
                            if(num % 4 != 0){
                                this.$message({
                                    showClose:true,
                                    message:"该楼层多件商品时应为4的整数倍",
                                    type:'error',
                                    center:true,
                                    duration:3000
                                })
                                return false
                            };
                        }
                    }
                    if(this.floorStyleTextIndex=='2'){
                        if(num!=6){
                            this.$message({
                                showClose:true,
                                message:"该楼层需添加6件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                    if(this.floorStyleTextIndex=='3'){
                        if(num<10){
                            this.$message({
                                showClose:true,
                                message:"该楼层至少添加10件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                    if(this.floorStyleTextIndex=='4'){
                        if(num<10){
                            this.$message({
                                showClose:true,
                                message:"该楼层至少添加10件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                    if(this.floorStyleTextIndex=='5'){
                        if(num<4){
                            this.$message({
                                showClose:true,
                                message:"该楼层至少添加4件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                    if(this.floorStyleTextIndex=='6'){

                    }
                    if(this.floorStyleTextIndex=='7'){
                        if(num<10){
                            this.$message({
                                showClose:true,
                                message:"该楼层至少添加10件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                }
                let arr = [...this.floorData];
                let obj = {
                    floorId: this.floorStyleId,
                    style: this.floorSelect,
                    name: this.floorName,
                    enabled: this.enableVal,
                    explain: this.floorExplain,
                    relation:this.relation,
                    data: [...this.floorClassDataAnother]
                };
                if(this.relation==true){
                    obj.categoryId=this.categoryId
                }
                obj.goodsNumber = obj.data.length;
                if(this.floorIsEdit){
                    if(this.classId!='') {
                        obj.id = this.floorData[this.floorIsEditIndex].id||'';
                        obj.rowId = this.floorData[this.floorIsEditIndex].rowId||'';
                    }
                    arr[this.floorIsEditIndex] = obj;
                    this.floorData = arr
                }else{
                    arr.push(obj);
                    this.floorData =  arr;
                }
            }
            this.floorVisible = false;
        },


        /*添加编辑楼层分类*/
        //添加分类并重置数据
        openClassWrap(){
            this.classTitle='';//分类名称
            this.floorClassData2=[];//分类商品列表
            this.classIsEdit=false;//是否是编辑
            this.classEditIndex='';//编辑第几个
            this.classVisible=true;
        },
        //提交
        classWrapBtn(){
            if(this.classTitle==''){
                this.$message({
                    showClose:true,
                    message:"请填写分类标题",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.floorClassData2.length==0){
                this.$message({
                    showClose:true,
                    message:"请填添加商品",
                    type:'error',
                    center:true,
                    duration:3000
                });
                return false
            }else{
                let data = this.floorList;
                for(let i = 0; i < data.length; i++){
                    console.log(data[i].style);
                    if(data[i].style=="floor1"&&data[i].selectActive==true){
                        if(this.floorClassData2.length<6){
                            this.$message({
                                showClose:true,
                                message:"请添加至少6件商品",
                                type:'error',
                                center:true,
                                duration:3000
                            });
                            return false
                        }
                    }
                }
            }
            if(this.classIsEdit){
                let data = {name:this.classTitle,data:this.floorClassData2};
                if(this.floorStyleTextIndex==0){
                    data.id = this.floorClassData[this.classEditIndex].id
                }
                let arr = this.floorClassData;
                arr[this.classEditIndex] = data;
                this.floorClassData = [...arr];
            }else{
                let data = {name:this.classTitle,data:this.floorClassData2};
                let arr = this.floorClassData;
                arr.push(data);
                this.floorClassData = [...arr];
            }
            this.classVisible=false;
        },
        //分类商品删除
        delFloorClassData2(index){
            this.floorClassData2.splice(index, 1);
        },

        /*添加商品*/
        //定价属性分组数据
        priceGroupingData(bol,bol2){
            let data = {
                categoryId:this.categoryId[this.categoryId.length-1],
                name:this.priceGroupingSearchName,
                pageNumber:this.priceGroupingGroupingPage,
                pageSize:this.priceGroupingGroupingSize
            };
            if(data.categoryId=='0'){
                data.categoryId = '';
            }
            //判断回显
            if(bol){
                //判断是楼层1之外的新增 bol2:true楼层1之外的新增
                if(bol2){
                    if(this.floorClassDataAnother.length!=0){
                        this.priceGroupingSearchActiveList = [...this.floorClassDataAnother]
                    }
                }else{
                    if(this.floorClassData2.length!=0){
                        this.priceGroupingSearchActiveList = [...this.floorClassData2]
                    }
                }
            }
            this.$ajax.get(goodeReviewedList2,data).then(res=>{
                console.log(res);
                for(let i = 0; i < res.data.rows.length; i++){
                    if(res.data.rows[i].posters.length!=3){
                        res.data.rows[i].bol = '';
                        continue;
                    }
                    if(this.priceGroupingSearchActiveList.length>0){
                        for(let j = 0; j < this.priceGroupingSearchActiveList.length; j++){
                            let id = this.priceGroupingSearchActiveList[j].itemId;
                            if(id==undefined){
                                id = this.priceGroupingSearchActiveList[j].id;
                            }
                            if(res.data.rows[i].id==id){
                                res.data.rows[i].bol = true;
                            }else{
                                res.data.rows[i].bol = false
                            }
                        }
                    }else{
                        res.data.rows[i].bol = false
                    }
                }
                this.priceGroupingSearchList = [...res.data.rows];
                this.priceGroupingGroupingCount = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //定价属性分组数据选择
        addPriceAttributesSelect(data,index){
            if(data.posters.length!=3){
                this.$message({
                    showClose:true,
                    message:"为了保证网站展示美观，只有上传宣传图的商品可被选择。",
                    type:"error",
                    center:true,
                    duration:3000
                });
                return false
            }
            let arr = this.priceGroupingSearchActiveList;
            arr.push(data);
            this.priceGroupingSearchActiveList = arr;
            let arr2 = this.priceGroupingSearchList;
            arr2[index].bol = true;
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组选择数据删除
        addPriceAttributesDel(data,index){
            let arr = this.priceGroupingSearchActiveList;
            arr.splice(index,1);
            let arr2 = this.priceGroupingSearchList;
            for(let i = 0; i < arr2.length; i++){
                if(data.id==arr2[i].id){
                    arr2[i].bol = false;
                    break
                }
            }
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组选择数据清空
        priceEmpty(){
            this.priceGroupingSearchActiveList = [];
            let arr2 = this.priceGroupingSearchList;
            for(let i = 0; i < arr2.length; i++){
                arr2[i].bol = false;
            }
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组数据提交
        priceGroupingBtn(type){
            if(this.priceGroupingSearchActiveList.length==0){
                this.$message({
                    showClose:true,
                    message:"请选择商品",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(type==1){
                //分类添加商品
                let dataList = this.priceGroupingSearchActiveList;
                this.floorClassData2 = [...dataList];
            }else if(type==0){
                // 非分类添加商品
                let dataList = this.priceGroupingSearchActiveList;
                this.floorClassDataAnother = [...dataList];
            }
            this.priceGroupingClose();
        },
        //定价属性分组数据取消
        priceGroupingClose(){
            this.priceGroupingSearchList = [];
            this.priceGroupingSearchActiveList = [];
            this.priceGrouping = false;
        },


        //楼层删除
        delFloorData(index){
            this.floorData.splice(index, 1);
        },
        //楼层编辑
        editFloorData(index){
            this.openFloorWrap(true,index)
        },
        //提交
        subBtn(){
            if(this.className==''){
                this.$message({
                    showClose:true,
                    message:"请输入分类名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.classImg==''){
                this.$message({
                    showClose:true,
                    message:"上传分类图标",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }

            let data = {
                name:this.className,//名称
                icon:{file:this.classImg,type:'IMAGE'},//图标
                parentId:'',//父级分类
                classificationValue:'',//关联的后台类目
                clickType:this.method,//配置方式
                enabled:this.wrapEnabled,//启禁用
            };
            if(this.classId!='') {
                data.icon.id = this.classImg.ids;
            }
            //父级分类
            if(this.parentClassValue!==''&&this.parentClassValue.length!=0){
                data.parentId = this.parentClassValue[this.parentClassValue.length-1];
            }
            //关联的后台类目
            if(this.classificationValue!=''&&this.classificationValue.length!=0){
                data.classificationIds = [this.classificationValue[this.classificationValue.length-1]];
                data.leaf = true;
            }else{
                data.leaf = false;
            }
            //手动配置
            if(this.method=='CUSTOMIZE'){
                if(this.bannerData.length<1){
                    this.$message({
                        showClose:true,
                        message:"请添加banner配置",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }
                if(this.floorData.length<1){
                    this.$message({
                        showClose:true,
                        message:"请添加楼层内容",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }
                //轮播图
                let arr = {items:[]};
                if(this.classId!=''){
                    if(this.bannerData.length>0&&this.bannerData[0].carouselId!=undefined&&this.bannerData[0].carouselId!='') {
                        arr.id = this.bannerData[0].carouselId;
                    }
                    for(let i = 0; i < this.bannerData.length; i++){
                        let obj= {
                            link:this.bannerData[i].bannerLinkUrl,
                            mediaItems:[{
                                file:this.bannerData[i].bannerImg,
                                type:"IMAGE"
                            }],
                        };
                        if(this.bannerData[i].mediaItemsId){
                            obj.mediaItems[0].id=this.bannerData[i].mediaItemsId
                        }
                        if(this.bannerData[i].itemsId!=undefined&&this.bannerData[i].itemsId!=''){
                            obj.id=this.bannerData[i].itemsId
                        }
                        arr.items.push(obj)
                    }
                }else{
                    for(let i = 0; i < this.bannerData.length; i++){
                        let obj= {
                            link:this.bannerData[i].bannerLinkUrl,
                            mediaItems:[{
                                file:this.bannerData[i].bannerImg,
                                type:"IMAGE"
                            }],
                        };
                        arr.items.push(obj)
                    }
                }
                data.carousel = arr;
                //楼层
                let floorArr = [];
                for(let i = 0; i < this.floorData.length; i++){
                    let obj = {
                        title:this.floorData[i].name,
                        subTitle:this.floorData[i].explain,
                        description:this.floorData[i].explain,
                        styleId:this.floorData[i].floorId,
                        itemType:"GOODS",
                        enabled:this.floorData[i].enabled,
                        relation:this.floorData[i].relation,
                        idx:i+1
                    };
                    if(this.floorData[i].relation&&this.floorData[i].categoryId){
                        obj.categoryId=this.floorData[i].categoryId[this.floorData[i].categoryId.length-1];
                    }
                    if(this.classId!='') {
                        if(this.floorData[i].id!=undefined&&this.floorData[i].id!=''){
                            obj.id = this.floorData[i].id;
                        }
                    }
                    let rowsArr = [];
                    if(this.floorData[i].style=='floor1'){
                        let floorData = this.floorData[i].data;
                        for(let j = 0; j < floorData.length; j++){
                            let floorObj = {};
                            let items = [];
                            floorObj.tab = floorData[j].name;
                            if(floorData[j].id!=undefined&&floorData[j].id!=''){
                                floorObj.id = floorData[j].id;
                            }
                            for(let k = 0; k < floorData[j].data.length; k++){
                                let itemsObj = {};
                                if(floorData[j].data[k].itemId!=undefined&&floorData[j].data[k].itemId!=''){
                                    itemsObj.id=floorData[j].data[k].id;
                                }else{
                                    itemsObj.itemId=floorData[j].data[k].id;
                                }
                                items.push(itemsObj)
                            }
                            floorObj.items = items;
                            rowsArr.push(floorObj)
                        }
                        obj.rows = rowsArr;
                    }else{
                        let floorData = this.floorData[i].data;
                        let floorObj = {};
                        let items = [];
                        for(let j = 0; j < floorData.length; j++){
                            if(floorData[j].itemId!=undefined&&floorData[j].itemId!=''){
                                items.push({id:floorData[j].id});
                            }else{
                                items.push({itemId:floorData[j].id});
                            }
                        }
                        floorObj.tab = this.floorData[i].style;
                        if(this.floorData[i].rowId!=undefined&&this.floorData[i].rowId!=''){
                            floorObj.id = this.floorData[i].rowId;
                        }
                        floorObj.items = items;
                        rowsArr.push(floorObj);
                        obj.rows = rowsArr;
                    }
                    floorArr.push(obj)
                }
                data.floors = floorArr
            }
            //跳转配置
            if(this.method=='OUTLINK'){
                data.link = this.linkUrl
                let bol = this.urlInspect(this.linkUrl);
                if(bol==false){
                    return false
                }
            };
            if(this.classId!='') {
                data.id = this.classId;
                this.$ajax.put(editReceptionClassList(this.classId),data).then(res=>{
                    console.log(res);
                    this.$router.replace({path:'/receptionClass'});
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }else{
                this.$ajax.post(addReceptionClassList,data).then(res=>{
                    console.log(res);
                    this.$router.replace({path:'/receptionClass'});
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }

        },

        //父级分类修改
        parentChange(val){
            if(val.length>1){
                this.method = 'OUTLINK';
                this.radioDisable = true
            }else{
                this.radioDisable = false
            }
        },
    },
    // 数据观察监听
    watch: {
        priceGroupingGroupingPage(newData,oldData){
            this.priceGroupingData();
        },
        //是否关联
        relation(newData,oldData){
            if(!this.relationType){
                if((this.floorClassData.length!==0||this.floorClassDataAnother.length!==0)&&this.isConfirm&&newData===true&&this.categoryId[0]!=='0'){
                    this.$confirm('此操作将清空已选择的商品数据', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // this.relation = newData;
                        this.isConfirm=true;
                        if(newData===false){
                            this.categoryId=['0']
                        }
                        this.floorClassData = [];//清空floor1的分类
                        this.floorClassDataAnother = [];//清空所有商品
                    }).catch(() => {
                        this.isConfirm=false;
                        this.relation = oldData;
                    });
                }
                if(newData===false){
                    this.categoryId=['0']
                }
            }
            this.isConfirm = true;
        },
        categoryId(newData,oldData){
            if(!this.relationType&&this.relation){
                if((this.floorClassData.length!==0||this.floorClassDataAnother.length!==0)&&this.isConfirm&&newData[0]!=='0'){
                    if((newData.length<oldData.length)&&oldData.indexOf(newData[newData.length-1])!==-1){
                        console.log('选择的同类的父级')
                    }else{
                        this.$confirm('此操作将清空已选择的商品数据', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            // this.relation = newData;
                            this.isConfirm=true;
                            this.floorClassData = [];//清空floor1的分类
                            this.floorClassDataAnother = [];//清空所有商品
                        }).catch(() => {
                            this.isConfirm=false;
                            this.categoryId = oldData;
                        });
                    }
                }
                // if(JSON.stringify(newData)===JSON.stringify(listData.categoryId)){
                //     if(listData.style=='floor1'){
                //         this.floorClassData = [...listData.data];
                //     }else{
                //         this.floorClassDataAnother = [...listData.data];
                //     }
                // }
            }
            this.isConfirm = true;
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.classificationList();

        if(this.$route.query.id!=undefined&&this.$route.query.id!=''){
            this.classId = this.$route.query.id;
            this.$ajax.get(searchReceptionClassList(this.$route.query.id),{id:this.$route.query.id}).then(res=>{
                console.log(res.data);
                if(res.data.children.length!=0){
                    this.classificationChildren = true
                }
                this.className = res.data.name;
                this.wrapEnabled = res.data.enabled;
                this.method = res.data.clickType;
                if(res.data.icon&&res.data.icon.content){
                    res.data.icon.content.ids = res.data.icon.id;
                    this.classImg = res.data.icon.content;
                }

                let arr = [];
                let arr2 = [];
                let timer = setInterval(function(){
                    if(this.parentClass.length!=0&&this.classification.length!=0){
                        if(res.data.parent!=''&&res.data.parent!=undefined){
                            for(let i = 0; i < this.parentClass.length; i++){
                                if(this.parentClass[i].value==res.data.parent.id){
                                    arr = [this.parentClass[i].value];
                                    break;
                                }else{
                                    if(this.parentClass[i].children!=undefined){
                                        for(let j = 0; j < this.parentClass[i].children.length; j++){
                                            if(this.parentClass[i].children[j].value==res.data.parent.id){
                                                arr = [ this.parentClass[i].value,this.parentClass[i].children[j].value];
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this.parentClassValue = arr;

                        if(res.data.classifications.length!=0){
                            for(let i = 0; i < this.classification.length; i++){
                                if(this.classification[i].value==res.data.classifications[0].id){
                                    arr2 = [this.classification[i].value];
                                    break;
                                }else{
                                    if(this.classification[i].children!=undefined){
                                        for(let j = 0; j < this.classification[i].children.length; j++){
                                            if(this.classification[i].children[j].value==res.data.classifications[0].id){
                                                arr2 = [ this.classification[i].value,this.classification[i].children[j].value];
                                                break;
                                            }else{
                                                if(this.classification[i].children[j].children!=undefined){
                                                    for(let k = 0; k < this.classification[i].children[j].children.length; k++){
                                                        if(this.classification[i].children[j].children[k].value==res.data.classifications[0].id){
                                                            arr2 = [ this.classification[i].value,this.classification[i].children[j].value,this.classification[i].children[j].children[k].value];
                                                            break;
                                                        }
                                                    }
                                                }

                                            }
                                        }
                                    }

                                }
                            }
                        }
                        this.classificationValue = arr2;
                        clearInterval(timer)
                    }
                }.bind(this),300)
                // if(res.data.clickType=='CUSTOMIZE'){
                    //banner回显
                    if(res.data.carousel){
                        let bannerArr = [];
                        for(let i = 0; i < res.data.carousel.items.length; i++){
                            let obj = {};
                            let imgObj =  res.data.carousel.items[i].mediaItems[0].content;
                            delete imgObj.id;
                            obj.bannerImg = imgObj;
                            obj.bannerLinkUrl =  res.data.carousel.items[i].link;
                            obj.itemsId = res.data.carousel.items[i].id;
                            obj.mediaItemsId = res.data.carousel.items[i].mediaItems[0].id;
                            obj.carouselId = res.data.carousel.id;
                            bannerArr.push(obj)
                        }
                        this.bannerData = bannerArr;
                    }
                    if(res.data.floors){
                        //楼层回显
                        let floorArr = [];
                        this.$ajax.get(floorStyle).then(resData=>{
                            let floorStyleData = resData.data.rows;//楼层样式
                            for(let i = 0; i < res.data.floors.length; i++){
                                let obj = {};
                                obj.id = res.data.floors[i].id;
                                obj.style = res.data.floors[i].style.style;
                                obj.name = res.data.floors[i].title;
                                obj.explain = res.data.floors[i].description;
                                obj.enabled = res.data.floors[i].enabled;
                                let num = 0;
                                obj.data = [];
                                if(obj.style=='floor1'){
                                    for(let j = 0; j < res.data.floors[i].rows.length; j++){
                                        num +=  res.data.floors[i].rows[j].items.length;
                                        let goodsObj = {};
                                        goodsObj.name = res.data.floors[i].rows[j].tab;
                                        goodsObj.id = res.data.floors[i].rows[j].id;
                                        for(let n = 0; n < res.data.floors[i].rows[j].items.length; n++){
                                            res.data.floors[i].rows[j].items[n].images = res.data.floors[i].rows[j].items[n].item.images;
                                            res.data.floors[i].rows[j].items[n].name = res.data.floors[i].rows[j].items[n].item.name;
                                            res.data.floors[i].rows[j].items[n].unionId = res.data.floors[i].rows[j].items[n].item.unionId;
                                            res.data.floors[i].rows[j].items[n].price = res.data.floors[i].rows[j].items[n].item.price;
                                        }
                                        goodsObj.data = res.data.floors[i].rows[j].items;
                                        obj.data.push(goodsObj)
                                    }
                                }else{
                                    num +=  res.data.floors[i].rows[0].items.length;
                                    for(let n = 0; n < res.data.floors[i].rows[0].items.length; n++){
                                        res.data.floors[i].rows[0].items[n].images = res.data.floors[i].rows[0].items[n].item.images;
                                        res.data.floors[i].rows[0].items[n].name = res.data.floors[i].rows[0].items[n].item.name;
                                        res.data.floors[i].rows[0].items[n].unionId = res.data.floors[i].rows[0].items[n].item.unionId;
                                        res.data.floors[i].rows[0].items[n].price = res.data.floors[i].rows[0].items[n].item.price;
                                    }
                                    obj.data=res.data.floors[i].rows[0].items;
                                    obj.rowId=res.data.floors[i].rows[0].id;
                                }
                                obj.goodsNumber = num;
                                obj.relation=res.data.floors[i].relation;//是否关联
                                if(res.data.floors[i].relation&&res.data.floors[i].category){
                                    let arr = []
                                    arr.push(res.data.floors[i].category.id)
                                    if(res.data.floors[i].category.parent!=undefined){
                                        arr.unshift(res.data.floors[i].category.parent.id)
                                        if(res.data.floors[i].category.parent.parent!=undefined){
                                            arr.unshift(res.data.floors[i].category.parent.parent.id)
                                        }
                                    }
                                    obj.categoryId=arr;
                                }else if(res.data.floors[i].relation&&res.data.floors[i].category==undefined){
                                    obj.categoryId=['0'];
                                }
                                obj.enabled = res.data.floors[i].enabled;
                                for(let j = 0; j < floorStyleData.length; j++){
                                    if(floorStyleData[j].style == res.data.floors[i].style.style){
                                        obj.floorId = floorStyleData[j].id
                                    }
                                }
                                floorArr.push(obj)
                            }
                            this.floorData = floorArr;
                            console.log(floorArr)
                        },err=>{
                            console.log(err);
                            this.$message({
                                showClose:true,
                                message:err.data,
                                type:'error',
                                center:true,
                                duration:3000
                            })
                        })
                    }
                    // let floorArr = [];
                    // this.$ajax.get(floorStyle).then(resData=>{
                    //     let floorStyleData = resData.data.rows;//楼层样式
                    //     for(let i = 0; i < res.data.floors.length; i++){
                    //         let obj = {};
                    //         obj.id = res.data.floors[i].id;
                    //         obj.style = res.data.floors[i].style.style;
                    //         obj.name = res.data.floors[i].title;
                    //         obj.explain = res.data.floors[i].description;
                    //         obj.enabled = res.data.floors[i].enabled;
                    //         let num = 0;
                    //         obj.data = [];
                    //         if(obj.style=='floor1'){
                    //             for(let j = 0; j < res.data.floors[i].rows.length; j++){
                    //                 num +=  res.data.floors[i].rows[j].items.length;
                    //                 let goodsObj = {};
                    //                 goodsObj.name = res.data.floors[i].rows[j].tab;
                    //                 for(let n = 0; n < res.data.floors[i].rows[j].items.length; n++){
                    //                     res.data.floors[i].rows[j].items[n].images = res.data.floors[i].rows[j].items[n].item.images;
                    //                     res.data.floors[i].rows[j].items[n].name = res.data.floors[i].rows[j].items[n].item.name;
                    //                     res.data.floors[i].rows[j].items[n].unionId = res.data.floors[i].rows[j].items[n].item.unionId;
                    //                     res.data.floors[i].rows[j].items[n].price = res.data.floors[i].rows[j].items[n].item.price;
                    //                 }
                    //                 goodsObj.data = res.data.floors[i].rows[j].items;
                    //                 obj.data.push(goodsObj)
                    //             }
                    //         }else{
                    //             num +=  res.data.floors[i].rows[0].items.length;
                    //             for(let n = 0; n < res.data.floors[i].rows[0].items.length; n++){
                    //                 res.data.floors[i].rows[0].items[n].images = res.data.floors[i].rows[0].items[n].item.images;
                    //                 res.data.floors[i].rows[0].items[n].name = res.data.floors[i].rows[0].items[n].item.name;
                    //                 res.data.floors[i].rows[0].items[n].unionId = res.data.floors[i].rows[0].items[n].item.unionId;
                    //                 res.data.floors[i].rows[0].items[n].price = res.data.floors[i].rows[0].items[n].item.price;
                    //                 // res.data.floors[i].rows[0].items[n].id = res.data.floors[i].rows[0].id;
                    //             }
                    //             obj.data=res.data.floors[i].rows[0].items
                    //         }
                    //         obj.goodsNumber = num;
                    //         obj.enabled = res.data.floors[i].enabled;
                    //         for(let j = 0; j < floorStyleData.length; j++){
                    //             if(floorStyleData[j].style == res.data.floors[i].style.style){
                    //                 obj.floorId = floorStyleData[j].id
                    //             }
                    //         }
                    //         floorArr.push(obj)
                    //     }
                    //     this.floorData = floorArr;
                    // },err=>{
                    //     console.log(err);
                    //     this.$message({
                    //         showClose:true,
                    //         message:err.data,
                    //         type:'error',
                    //         center:true,
                    //         duration:3000
                    //     })
                    // })
                // }
                // if(res.data.clickType=='OUTLINK'){
                    this.linkUrl = res.data.link;
                // }
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        }
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
